import type { CSSProperties, ReactNode } from "react";
import { Text } from "../../theme/primitives";

interface SidePanelProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
}

/** A right-side drawer with a slate header and an overlay backdrop. */
export function SidePanel({ title, onClose, children }: SidePanelProps) {
  return (
    <div onClick={onClose} style={overlay}>
      <div onClick={(e) => e.stopPropagation()} style={panel}>
        <div style={header}>
          <Text weight="bold" size="lg" style={{ color: "var(--color-header-text)" }}>
            {title}
          </Text>
          <button onClick={onClose} aria-label="Close" style={closeButton}>
            ✕
          </button>
        </div>
        <div style={{ overflowY: "auto", flex: 1 }}>{children}</div>
      </div>
    </div>
  );
}

const overlay: CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "var(--color-overlay)",
  display: "flex",
  justifyContent: "flex-end",
  zIndex: 20,
};

const panel: CSSProperties = {
  width: "min(380px, 100%)",
  height: "100%",
  background: "var(--color-panel)",
  display: "flex",
  flexDirection: "column",
  boxShadow: "var(--shadow-md)",
};

const header: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "var(--space-md) var(--space-lg)",
  background: "var(--color-header-bg)",
};

const closeButton: CSSProperties = {
  background: "transparent",
  border: "none",
  color: "var(--color-header-text)",
  fontSize: 18,
  cursor: "pointer",
};
